import { CtaButton } from '@/components/astro/cta-button/cta-button';

import { useTrialDays } from '@/server/services/pricing-service';

export function FaqSection() {
  const trialDays = useTrialDays();

  const faqData = [
    {
      question:
        'Can it pronounce difficult words, like “Mesothelioma” or “Diphenhydramine”?',
      answer:
        'Yep. If our audio ever mispronounces a word, just let us know and we’ll fix it.',
    },
    {
      question: `What happens if I cancel during the ${trialDays.toString()} days trial?`,
      answer: "You won't get billed at all!",
    },
    {
      question: 'I only want to listen to the Abstract and Results.',
      answer: 'Just uncheck the checkboxes for the sections you want to skip!',
    },
    {
      question:
        'I don’t want to listen to all the references and citations. Can your app skip those?',
      answer: 'Yes, we skip those, so you can focus on the core material.',
    },
  ];

  return (
    <section className='flex flex-col items-center gap-18 px-5 py-18 sm:px-14 lg:px-18'>
      <div className='flex flex-col items-center gap-4 sm:gap-4'>
        <h2 className='text-center text-[40px] leading-[43px] font-[700] text-neutral-945 lg:text-[48px] lg:leading-[64px]'>
          F.A.Q
        </h2>
        <div className='text-center text-[16px] leading-[24px] font-[500] text-neutral-700 sm:text-[24px] sm:leading-[36px] lg:text-[20px] lg:leading-[30px]'>
          We have put together some commonly asked questions
        </div>
      </div>
      <div className='grid max-w-[1296px] grid-cols-1 gap-4 sm:gap-12 md:grid-cols-2 md:gap-[24px]'>
        {faqData.map((faq, index) => (
          <div
            className='relative flex flex-col items-start gap-[40px] rounded-[32px] bg-white px-[24px] pt-[24px] pb-[48px] [box-shadow:0_4px_36px_rgba(193,_216,_251,_.5)]'
            key={`faq-${index.toString()}`}
          >
            <div className='flex flex-col gap-4 sm:gap-6'>
              <div className='flex size-14 items-center justify-center rounded-full bg-azure-455/10'>
                <div className='text-[24px] leading-[36px] font-[500] text-azure-455'>
                  {(index + 1).toString().padStart(2, '0')}
                </div>
              </div>
              <div className='text-[20px] leading-[24px] font-[500] text-neutral-945'>
                {faq.question}
              </div>
              <div className='text-[16px] leading-[28px] font-[500] text-neutral-420 sm:text-[20px] sm:leading-[36px]'>
                {faq.answer}
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15' />
            </div>
          </div>
        ))}
      </div>
      <CtaButton className='inline-block h-auto cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[18px] leading-[24px] font-[500] text-neutral-50 no-underline sm:px-6 sm:text-[28px] sm:leading-[37px] lg:px-16 lg:py-5' />
    </section>
  );
}
